import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AnimatedRoutes } from "@/components/AnimatedRoutes";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { initGlobalClickTracking } from "@/lib/analytics";
import { initPerfTracking } from "@/lib/perfTracking";
import { initLinkPrefetch } from "@/lib/routePrefetch";
import { initConversionTracking } from "@/lib/conversionTracking";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    initGlobalClickTracking();
    initConversionTracking();
    initPerfTracking();
    const stopPrefetch = initLinkPrefetch();
    return stopPrefetch;
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ErrorBoundary>
          <AnimatedRoutes />
        </ErrorBoundary>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
